
export const getCurrentWebsite = (): string => {
	const domain = window.location.hostname;
	let websiteCode;
	switch (domain) {
		case 'huopenair.com':
			websiteCode = 'HU'
			break
		case 'altomincio.humancompany.com':
		case 'altomincio.huopenair.com':
			websiteCode = 'AM'
			break
		case 'venezia.humancompany.com':
		case 'venezia.huopenair.com':
			websiteCode = 'JO'
			break
		case 'firenze.humancompany.com':
		case 'firenze.huopenair.com':
			websiteCode = 'CF'
			break
		case 'norcenni.humancompany.com':
		case 'norcenni.huopenair.com':
			websiteCode = 'NG'
			break
		case 'parkalbatros.humancompany.com':
		case 'parkalbatros.huopenair.com':
			websiteCode = 'PA'
			break
		case 'montescudaio.humancompany.com':
		case 'montescudaio.huopenair.com':
			websiteCode = 'MS'
			break
		case 'roma.humancompany.com':
		case 'roma.huopenair.com':
			websiteCode = 'RO'
			break
		case 'fabulous.humancompany.com':
		case 'fabulous.huopenair.com':
			websiteCode = 'FA'
			break
		case 'ipini.humancompany.com':
		case 'ipini.huopenair.com':
			websiteCode = 'IP'
			break
		case 'birkelt.humancompany.com':
		case 'birkelt.huopenair.com':
			websiteCode = 'BK'
			break
		case 'humantravel.com':
		case 'www.humantravel.com':
			websiteCode = 'EV'
			break
		case 'humancompany.com':
			websiteCode = 'HU'
			break
		case 'firenzecertosacamping.com':
			websiteCode = 'CE'
			break
		case 'palagina.it':
		case 'www.palagina.it':
			websiteCode = 'VP'
			break
		case 'casalelecorti.com':
			websiteCode = 'LC'
			break
		case 'ladigahotel.com':
			websiteCode = 'LD'
			break
		case 'villanorcenni.com':
			websiteCode = 'VN'
			break
		case 'ilmulinacciohotel.com':
			websiteCode = 'MU'
			break
		default:
			websiteCode = 'HU'
	}
	return websiteCode
};


export const getPrivacyLink = () => {
	let privacyLink;
	switch (getCurrentWebsite()) {
		case 'HU':
			privacyLink = '<a target="_blank" href="https://huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'NG':
			privacyLink = '<a target="_blank" href="https://norcenni.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'AM':
			privacyLink = '<a target="_blank" href="https://altomincio.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'PA':
			privacyLink = '<a target="_blank" href="https://parkalbatros.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'MS':
			privacyLink = '<a target="_blank" href="https://montescudaio.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'IP':
			privacyLink = '<a target="_blank" href="https://ipini.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'BK':
			privacyLink = '<a target="_blank" href="https://birkelt.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'CE':
			privacyLink = '<a target="_blank" href="https://firenzecertosacamping.com/privacy-policy">Privacy Policy</a>'
			break
		case 'RO':
			privacyLink = '<a target="_blank" href="https://roma.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'CF':
			privacyLink = '<a target="_blank" href="https://firenze.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'JO':
			privacyLink = '<a target="_blank" href="https://venezia.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		case 'FA':
			privacyLink = '<a target="_blank" href="https://fabulous.huopenair.com/privacy-policy">Privacy Policy</a>'
			break
		default:
			privacyLink = '<a target="_blank" href="https://huopenair.com/privacy-policy">Privacy Policy</a>'
	}
	return privacyLink;
};

export const getTermsLink = () => {
  let termsLink;
  switch (getCurrentWebsite()) {
    case 'HU':
      termsLink = '<a target="_blank" href="https://huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'NG':
      termsLink = '<a target="_blank" href="https://norcenni.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'AM':
      termsLink = '<a target="_blank" href="https://altomincio.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'PA':
      termsLink = '<a target="_blank" href="https://parkalbatros.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'MS':
      termsLink = '<a target="_blank" href="https://montescudaio.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'IP':
      termsLink = '<a target="_blank" href="https://ipini.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'BK':
      termsLink = '<a target="_blank" href="https://birkelt.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'CE':
      termsLink = '<a target="_blank" href="https://firenzecertosacamping.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'RO':
      termsLink = '<a target="_blank" href="https://roma.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'CF':
      termsLink = '<a target="_blank" href="https://firenze.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'JO':
      termsLink = '<a target="_blank" href="https://venezia.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    case 'FA':
      termsLink = '<a target="_blank" href="https://fabulous.huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
      break
    default:
      termsLink = '<a target="_blank" href="https://huopenair.com/general-terms-and-conditions">Terms and conditions</a>'
  }
  return termsLink;
};
